import * as environments from 'src/environments.json';
const env = environments.default[process.env.REACT_APP_ENVIRONMENT.trim()];

const USE_CASE_URL = 'headquarter-customers';

const downloadCustomerDocumentPdfByIndex = ({
  headquarterCustomerId,
  documentIndex
}) => {
  const url = `${env.api.url}/${USE_CASE_URL}/download/document?headquarterCustomerId=${headquarterCustomerId}&documentIndex=${documentIndex}`;

  window.location = url;
};

export default downloadCustomerDocumentPdfByIndex;
